module.exports = __webpack_public_path__ + "img/pixing_xc16.68b88098.jpg";